/*
 * @Description:
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-03 09:35:44
 * @LastEditors: zhangle
 * @LastEditTime: 2024-01-30 17:32:06
 */
import qs from 'qs'
/**
 * 请求统一管理
 */
import Request from '@/common/copyright/request';
// 按剧集作品草稿ID查询消费信息
export const draftConsumeInfoApi = (id) => Request.get(`drama/api/order/consumeInfo?id=${id}`);